import type {MetadataId} from 'types';

export const isMetadataId = (entity: unknown): entity is MetadataId => {
  return (
    !!(entity && (entity as MetadataId)?.workId) ||
    !!(entity && (entity as MetadataId)?.ean)
  );
};
